
import React, {Component} from 'react';
import ReportGeneralTable from './ReportGeneralTable'
import PettyCashDoc from '../cashflow/PettyCashDoc'
import ReportStore from '../../stores/ReportStore'
import Moment from 'moment'
class ReportPettyCashPage extends Component {

  constructor(...args){
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    const optionsMonth = [
      { value: 0, label: 'ทั้งปี' },
      { value: '01', label: 'มกราคม' },
      { value: '02', label: 'กุมภาพันธ์' },
      { value: '03', label: 'มีนาคม' },
      { value: '04', label: 'เมษายน' },
      { value: '05', label: 'พฤษภาคม' },
      { value: '06', label: 'มิถุนายน' },
      { value: '07', label: 'กรกฎาคม' },
      { value: '08', label: 'สิงหาคม' },
      { value: '09', label: 'กันยายน' },
      { value: '10', label: 'ตุลาคม' },
      { value: '11', label: 'พฤศจิกายน' },
      { value: '12', label: 'ธันวาคม' }
    ];

    this.state = {
      showTable: true,
      data: [],
      length: 10,
      totalPage: 0,
      loading: false,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      defaultMonth: 0,
      defaultYear: yTh,
      type: 'tool',
      record_type: 'request_purchase'
    }
    this.poTable = null
  }

  componentDidMount() {
    
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    ReportStore.loadPettycashList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,callback)
  }


  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }


  renameDoc(newPoNo){
    this.refs.poDoc.renameDoc(newPoNo)
  }

  showTable(){
    this.setState({showTable:true})
    if(this.poTable!==null)
      this.poTable.refreshTable() 
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    
    this.setState({showTable:false})
    this.refs.poDoc.loadData(item.pettycash_no)
    if(this.props.onDocShow!==undefined){
      this.props.onDocShow(item.pettycash_no)
    }
  }

  onDocNew(recordid){
    this.setState({showTable:false})
    let that = this
    this.refs.poDoc.loadNewDoc(recordid,function(item){
      if(that.props.onDocShow!==undefined){
        that.props.onDocShow(item.purchase_order_no)
      }
    })    
  }

  renderStatus(status,row){
    let result = (<span></span>)

    if (row.status==0) {
      result = (<span className="label label-default" data-value="0">เริ่มต้น</span>)
    }else if (row.status==1) {
      result = (<span className="label label-primary" data-value="1">อนุมัติ</span>)
    } else if (row.status==2) {
      result = (<span className="label label-primary" data-value="2">รับของเรียบร้อย</span>)
    } else if (row.status==3) {
      result = (<span className="label label-success" data-value="3">นำเข้าสต็อกเรียบร้อย</span>)
    } else if (row.status==4) {
      result = (<span className="label label-success" data-value="4">นำไปซ่อมแล้ว</span>)  
    } else{
      result = (<span></span>)
    }

    return result
  }

  onRenderColumn(data,col,row){ 

    if(col===9){ 
      return this.renderStatus(data,row)     
    } else if (col===7) {
      return (<span style={{color:(data<0?'red':'')}}>{data}</span>)
    } else{ 
      return (<span>{data}</span>)
    }
  }

  onDocClose(){
    this.showTable() 
  }


  renderCustomFooter(headerTitles,e) {
    let sum = 0
    e.forEach(function(item,index) {
      let amount = item.amount
      if (amount===''||amount===null||amount===undefined||isNaN(amount))
        amount = 0

      sum += parseFloat(amount)
    })
    return(
      <tfoot>
        <tr>
        {
          headerTitles.map((item,index)=>{
            return(
              <th className={item.title==='มูลค่า(บาท)'?'text-right':'text-center'} key={index}>{item.title==='มูลค่า(บาท)'?'รวม '+this.getNumberFormat(sum):item.title}</th>
            )
          })
        }
        </tr>
      </tfoot>  
    )
  }

  render(){
    let {showTable} = this.state
    const headerTitles = [
      {title:'วันที่ออก',width:'100px'},
      {title:'เลขที่เอกสาร',width:'150px'},
      {title:'ชื่อผู้เบิก',width:'150px'},
      {title:'แผนก',width:'150px'},
      {title:'จำนวนเงิน(บาท)',width:'150px'},
      {title:'หมายเหตุ'}  
    ]
    const searchOptions = [
      {
        label: 'ชื่อผู้เบิก',
        value: 'request_by'
      },
      {
        label: 'หมายเลขใบสำคัญจ่ายเงินสดย่อย',
        value: 'pettycash_no'
      }      
    ]

    
     return (
          <div>
              <div style={{display:showTable?'block':'none'}}>
                <ReportGeneralTable 
                  onRef={(ref)=>{this.poTable = ref}}
                  title='ใบสำคัญจ่ายเงินสดย่อย' 
                  headerTitles={headerTitles}
                  searchOptions={searchOptions}
                  searchBy={'pettycash_no'}
                  excludeColumn={['status']}
                  loadData={this.loadData.bind(this)}
                  onRowSelect={this.onRowSelect.bind(this)} 
                  onDocNew={this.onDocNew.bind(this)}
                  onRenderColumn={this.onRenderColumn.bind(this)}
                  customFooter={true}
                  renderCustomFooter={this.renderCustomFooter.bind(this,headerTitles)}
                  minWidth={'1300'}
                />
              </div>  
              <div style={{display:!showTable?'block':'none'}}>
                <PettyCashDoc ref='poDoc' onClose={this.onDocClose.bind(this)}/>
              </div>
          </div>          
     )
  }
}

ReportPettyCashPage.defaultProps = {
  mode: 'report'
}
export default ReportPettyCashPage;


// WEBPACK FOOTER //
// ./src/view/report/ReportPettyCashPage.js